import {List} from 'immutable'

import {cleanResponse} from '../redux/apiHelper'

import {RESHAPE_VIEWS} from '../actions/corpMaxActionTypes'

const viewsReducer = (state = List(), action) => {
  switch (action.type) {
    case RESHAPE_VIEWS:
      return cleanResponse(action.payload)
    default:
      return state
  }
}

export default viewsReducer
